import React from 'react';

import { skeleton as Skeleton } from '@breezeway/brzw-components';

import './comment_skeleton.scss';

const CLASS_NAME = 'comment-skeleton';

const CommentSkeleton = () => (
  <Skeleton.SkeletonBar
    className={`${CLASS_NAME}__bar`}
    theme={Skeleton.constants.SKELETON_THEMES.GRAY_LIGHT}
  />
);

export default CommentSkeleton;
